// extracted by mini-css-extract-plugin
export default {"address":"styles_address__rXUzs","orderDate":"styles_orderDate__W5Uzd"};